import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
